<ng-container *ngIf="(files$ | async) as files">
  <div class="container mt-4">
    <div class="row justify-content-end mb-4">
      <!-- Ordinamento -->
      <div class="col-auto d-inline-block">
        <div ngbDropdown class="d-inline-block" container="body">
          <button type="button" class="btn btn-outline-primary btn-xs" [id]="'sortyBy' + props?.label"
            ngbDropdownToggle>
            Ordina per:
          </button>
          <div ngbDropdownMenu [attr.aria-labelledby]="'sortyBy' + props?.label" appendTo="body">
            <div ngbDropdownItem *ngFor="let order of sortByOptions" class=" ps-3 p-0">
              <input (change)="sortFiles(order.value)" class="form-check-input p-0" type="radio"
                [name]="order.label+'cardfiles'" [id]="order.label+'cardfiles'" [checked]="order.value === sortBy"
                [value]="order.value">
              <label class="form-check-label ps-2" style="font-size: .9rem;" [for]="order.label+'cardfiles'">
                {{ order?.label }}
              </label>
            </div>
          </div>
        </div>
      </div> <!-- /end of Ordinamento -->
      <div class="col-auto  d-inline-block" *ngIf="viewTemplate === 'pagination'">
        <div ngbDropdown class="d-inline-block" container="body">
          <button type="button" class="btn btn-outline-primary btn-xs" ngbDropdownToggle>
            {{ 'Elementi per pagina: ' + pageSize }}
          </button>
          <div ngbDropdownMenu [attr.aria-labelledby]="'pageSize' + props?.label" appendTo="body">
            <button ngbDropdownItem *ngFor="let size of [3, 6, 9, 12]" class=" ps-3 p-0" (click)="onPageSize(size)">
              {{ size }}
            </button>
          </div>
        </div>
      </div> <!-- /Elementi per pagina -->
    </div>
    <ng-container [ngSwitch]="viewTemplate">
      <!--  CAROUSEL TEMPLATE -->
      <ng-container *ngSwitchCase="'carousel'">
        <ngb-carousel #carousel [showNavigationArrows]="true" [keyboard]="true" [showNavigationIndicators]="false"
          [interval]="0">
          <ng-template ngbSlide *ngFor="let group of files | groupFiles: (elementsToShow$ | async) || 3">
            <div class="row justify-content-center px-5">
              <div class="card-wrapper col-4" *ngFor="let file of group">
                <!-- card template outlet-->
                <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: file }"></ng-container>
                <!-- /end of card template outlet -->
              </div>
            </div>
          </ng-template>
        </ngb-carousel>
      </ng-container>

      <!-- PAGINATION TEMPLATE -->
      <ng-container *ngSwitchCase="'pagination'">
        <div class="row ps-3 w-100 justify-content-center">
          <div class="col-auto mb-2 p-0 me-3" *ngFor="let file of paginatedFiles">
            <!--card template outlet -->
            <div class="card-wrapper ">
              <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: file }"></ng-container>
            </div> <!--/end of card template outlet-->
          </div>
        </div>
        <ngb-pagination class="d-flex justify-content-center" [collectionSize]="files.length" [(page)]="page"
          [pageSize]="pageSize" size="sm" (pageChange)="onPageChange($event)"></ngb-pagination>
      </ng-container>

      <!-- GRID TEMPLATE -->
      <ng-container *ngSwitchDefault>
        <div class="row ps-3 w-100 justify-content-center">
          <div class="col-auto mb-2 p-0 me-3" *ngFor="let file of files">
            <!--card template outlet -->
            <div class="card-wrapper ">
              <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: file }"></ng-container>
            </div> <!--/end of card template outlet-->
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #cardTemplate let-file>
  <div class="card shadow-sm border-0" style="max-width: 100%; padding: 1rem;">
    <div class="card-body" style="padding:0">
      <p class="card-text" style="font-size: 0.875rem; color: #555;">
        <strong> Titolo:</strong> {{ getFileTitle(file) }} <br>
        <strong> Descrizione:</strong> {{ file?.description || '-' }} <br>
      </p>
      <div class="d-flex justify-content-center gap-2 mt-3">
        <button class="btn btn-outline-primary btn-sm" (click)="showPreview(file)">
          <i class="bi bi-eye"></i> Preview
        </button>
        <button class="btn btn-outline-success btn-sm" (click)="downloadFile(file)">
          <i class="bi bi-download"></i> Download
        </button>
      </div>
    </div>
  </div>
</ng-template>